// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"9be52407","193":"7a3c628a","252":"708c4ce7","313":"badaec75","453":"a1d37df4","458":"acd2c401","500":"9c2e16f7","538":"ab09597e","550":"a724e47d","556":"26bdd525","751":"639f2d21","786":"e6279077","896":"69216cf3","921":"ce3ed7a3"}[chunkId] + ".chunk.js";
};